import Echo from "laravel-echo";
import React, { useEffect, useState } from "react";
// eslint-disable-next-line no-unused-vars
import Pusher from "pusher-js";
import posthog from "posthog-js";
import { useSelector } from "react-redux";
import { NotificationContext, SocketContext, CurrencyContext } from "./Context";

const InitContext = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const { user } = useSelector((state) => state.auth);
  const [currency, setCurrency] = useState("$");
  const [loading, setLoading] = useState(false);
  const [baseCurrency, setBaseCurrency] = useState({ iso: "USD", symbol: "$", name: "Dolar" });

  const notis = { notifications, setNotifications };
  const currencies = {
    currency,
    setCurrency,
    loading,
    setLoading,
    baseCurrency,
    setBaseCurrency,
  };

  useEffect(() => {
    if (user?.token) {
      posthog.identify(user.token, {
        name: `${user.firstname} ${user.lastname}`,
        role: user.role,
      });
    } else {
      posthog.reset();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.token]);

  useEffect(() => {
    if (user?.token && import.meta.env.VITE_PUSHER_APP_KEY) {
      try {
        const echo = new Echo({
          broadcaster: "pusher",
          key: import.meta.env.VITE_PUSHER_APP_KEY,
          cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
          wsHost: "127.0.0.1",
          name: "Homelan",
          authEndpoint: `${import.meta.env.VITE_API_URL}/api/broadcasting/auth`,
          auth: {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${user?.token}`,
            },
          },
          wsPort: 6001,
          forceTLS: false,
          disableStats: true,
          enabledTransports: ["ws"],
        });

        setSocket(echo);
      } catch (error) {
        console.error("Error al inicializar Laravel Echo / Pusher:", error);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <NotificationContext.Provider value={notis}>
      <SocketContext.Provider value={socket}>
        <CurrencyContext.Provider value={currencies}>
          {children}
        </CurrencyContext.Provider>
      </SocketContext.Provider>
    </NotificationContext.Provider>
  );
};

export default InitContext;
